export default __webpack_public_path__ + "static/media/Salient Features_USHPP_2.c25179b6.jpg";